
    module.exports = {
      bytes: 257669,
      height: 159,
      orientation: undefined,
      src: __webpack_public_path__ + "ca18d20135a626f3731f78cf6a589cbc.svg",
      type: "svg",
      width: 215,
    };
    /**
     * For requires from CSS when used with webpack css-loader,
     * outputting an Object doesn't make sense,
     * so overriding the toString method to output just the URL.
     */
    module.exports.toString = function() {
      return __webpack_public_path__ + "ca18d20135a626f3731f78cf6a589cbc.svg";
    };
  